import { Status as p } from "../../../../../../../common/shared/status.js";
import { ScopeModel as A } from "../../../../../../features/api/models/scope/scope.model.js";
import { useBookingAvailability as g } from "../../../../../../features/api/repositories/booking/useBookingAvailability.js";
import { BookingAvailabilityStatus as a } from "../../../../../../features/api/models/booking/availability/bookingAvailabilityStatus.enum.js";
import m from "../../../hooks/customization/useCustomization.js";
import { useBooking as v } from "../context.js";
function y() {
  const {
    configuration: n
  } = m(), {
    mutateAsync: c,
    isLoading: u
  } = g(), {
    setCurrentStep: s
  } = v();
  async function d(t) {
    try {
      const r = (n == null ? void 0 : n.settings.configuration.scope.filter((e) => {
        var i;
        return ((i = e.services.booking) == null ? void 0 : i.status) === p.ENABLED;
      }).map((e) => e.id)) ?? [];
      if (t.day === void 0)
        return;
      const l = await c({
        address: t.place ? {
          address: t.place.formattedAddress,
          latitude: t.place.lat ?? 0,
          longitude: t.place.long ?? 0
        } : void 0,
        people: t.people,
        date: t.day,
        time: t.hour,
        scope: new A([], r)
      });
      if (![
        a.AVAILABLE,
        a.PARTIALLY_AVAILABLE
      ].includes(l.status))
        throw new Error(`Booking is not available, status ${l.status}`);
      const o = l.items.filter((e) => e.alternativePeople.length === 0 || e.status === a.AVAILABLE);
      if (o.length === 0)
        throw new Error("Booking unavailable for the current selected of people");
      if (o.length === 1 && o.every((i) => i.status === a.AVAILABLE)) {
        s({
          name: "confirmation",
          data: {
            bookingItem: o[0],
            confirmedHour: t.hour
          }
        });
        return;
      }
      s({
        name: "selection",
        data: {
          bookingItems: o
        }
      });
    } catch {
      s({
        name: "noMatch",
        data: void 0
      });
    }
  }
  return {
    proceed: d,
    isLoading: u
  };
}
export {
  y as useBookingServiceAction
};
//# sourceMappingURL=useBookingServiceAction.js.map
